/* ============================================================
   SOLVEY · productpagina-bundel (P1.4b, 2026-10-05)
   ------------------------------------------------------------
   Eén bestand in plaats van ca. 35 losse scripts. Welke onderdelen
   draaien, bepaalt window.SOLVEY_PDP (gezet in layout/theme.liquid,
   met dezelfde voorwaarden als de oude <script>-tags):
     kit         product-handle voor bullets en Trustpilot (was de
                 handle-check in elk solvey-<x>-bullets/-trustpilot.js)
     bullets     3 (losse producten) of 5 (bundels); 0 = geen
     trustpilot  'rating' (PDP's) of 'below-price' (Restore Probiotics)
     ritualCta   Restore: ritueel-knop -> abonnement in de winkelwagen
     preorder    pre-order-labels (Restore + bundels met Restore)
     core        frequentie-dropdown, header, Firmhouse-i18n, VIP-kaart
     gift        gratis-crème-kaart
   Elk onderdeel is de oorspronkelijke code en draait in een eigen
   try/catch: een fout in één onderdeel stopt de rest niet (zoals bij
   losse bestanden). Teksten komen uit window.solveyI18n
   (snippets/solvey-i18n.liquid, laadt in <head>).
   Nieuwe PDP: in layout/theme.liquid svp_kit / svp_bullets / svp_trust
   zetten in het blok van die productpagina.
   ============================================================ */
(function () {
  var cfg = window.SOLVEY_PDP || {};
  function mod(name, on, fn) {
    if (!on) return;
    try { fn(); } catch (e) { if (window.console) console.error('[solvey-pdp] ' + name, e); }
  }

  /* ---- bullets — was solvey-<x>-bullets.js (13x) en restore-probiotics-bullets.js; iconen in de abonnementskaart ---- */
  mod('bullets', cfg.kit && cfg.bullets, function () {
    (function () {
      if (!document.body.classList.contains('product-handle--' + cfg.kit)) return;

      var ICONS = {
        leaf:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/>' +
          '<path d="M2 21c0-3 1.85-5.36 5.08-6"/>' +
          '</svg>',
        refreshCw:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"/>' +
          '<path d="M21 3v5h-5"/>' +
          '<path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"/>' +
          '<path d="M3 21v-5h5"/>' +
          '</svg>',
        shieldCheck:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"/>' +
          '<path d="m9 12 2 2 4-4"/>' +
          '</svg>',
        stethoscope:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M11 2v2"/>' +
          '<path d="M5 2v2"/>' +
          '<path d="M5 3H4a2 2 0 0 0-2 2v4a6 6 0 0 0 12 0V5a2 2 0 0 0-2-2h-1"/>' +
          '<path d="M8 15a6 6 0 0 0 12 0v-3"/>' +
          '<circle cx="20" cy="10" r="2"/>' +
          '</svg>',
        users:
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
          '<path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>' +
          '<circle cx="9" cy="7" r="4"/>' +
          '<path d="M22 21v-2a4 4 0 0 0-3-3.87"/>' +
          '<path d="M16 3.13a4 4 0 0 1 0 7.75"/>' +
          '</svg>'
      };

      // Teksten uit locales/*.json via window.solveyI18n (snippets/solvey-i18n.liquid);
      // Engelse tekst (= bron in restore-probiotics-bullets.js) als fallback.
      var i18n = function (k, fb) { return (window.solveyI18n && window.solveyI18n[k]) || fb; };
      var BULLETS = [
        { icon: ICONS.users,       text: i18n('sub_bullet_trusted', 'Trusted by 30,000+ women') },
        // Bundels (cfg.bullets === 5) krijgen twee extra bullets; losse producten 3.
        cfg.bullets === 5 && { icon: ICONS.leaf,        text: i18n('sub_bullet_natural', '100% Natural & Clinically Tested') },
        cfg.bullets === 5 && { icon: ICONS.stethoscope, text: i18n('sub_bullet_expert', 'Expertly developed with gynecological input') },
        { icon: ICONS.shieldCheck, text: i18n('sub_bullet_guarantee', '60-day money-back guarantee') },
        { icon: ICONS.refreshCw,   text: i18n('sub_bullet_flexible', 'Flexible subscription, cancel anytime') }
      ].filter(Boolean);

      var BULLETS_HASH = BULLETS.map(function (b) { return b.text; }).join('|');

      var TARGET_SELECTOR = '.selling_plan_app_container li.subscription-card .card-content';
      var ROOT_SELECTOR   = '.selling_plan_app_container';
      var INJECTED_FLAG   = 'data-solvey-injected';

      function buildList() {
        var ul = document.createElement('ul');
        ul.className = 'solvey-sub-bullets';
        ul.setAttribute(INJECTED_FLAG, 'true');
        ul.dataset.bulletsHash = BULLETS_HASH;
        BULLETS.forEach(function (b) {
          var li = document.createElement('li');
          li.innerHTML = b.icon + '<span>' + b.text + '</span>';
          ul.appendChild(li);
        });
        return ul;
      }

      function inject() {
        var targets = document.querySelectorAll(TARGET_SELECTOR);
        for (var i = 0; i < targets.length; i++) {
          var existing = targets[i].querySelector('.solvey-sub-bullets[' + INJECTED_FLAG + '="true"]');
          if (existing) {
            if (existing.dataset.bulletsHash === BULLETS_HASH) continue;
            existing.parentNode.removeChild(existing);
          }
          targets[i].appendChild(buildList());
        }
      }

      // Verwijder de NL/EN-frequency-labels uit de Firmhouse-cards:
      // "elke", "each", "per stuk", "per piece". Loopt door tekst-nodes
      // binnen .selling_plan_app_container en filtert die strings eruit.
      function cleanLabels() {
        var roots = document.querySelectorAll(ROOT_SELECTOR);
        for (var r = 0; r < roots.length; r++) {
          var walker = document.createTreeWalker(roots[r], NodeFilter.SHOW_TEXT, null);
          var node;
          while ((node = walker.nextNode())) {
            var orig = node.nodeValue;
            if (!orig || !/(per\s+stuk|per\s+piece|\belke\b|\beach\b|\b(?:pro|je)\s+st(?:ü|ue)ck|\balle\s+\d)/i.test(orig)) continue;
            // DE: "pro/je Stück" en "alle 6 Wochen" -> "6 Wochen" (alleen vóór een cijfer).
            var updated = orig
              .replace(/\s*\bper\s+stuk\b\.?/gi, '')
              .replace(/\s*\bper\s+piece\b\.?/gi, '')
              .replace(/\s*\b(?:pro|je)\s+st(?:ü|ue)ck\.?/gi, '')
              .replace(/\b(elke|each)\s+/gi, '')
              .replace(/\b(elke|each)\b/gi, '')
              .replace(/\balle\s+(?=\d)/gi, '')
              .replace(/\s{2,}/g, ' ')
              .replace(/\s+([.,;:!?])/g, '$1')
              .replace(/^[\s\/|·•·]+|[\s\/|·•·]+$/g, '');
            if (updated !== orig) node.nodeValue = updated;
          }
        }
      }

      function applyAll() {
        inject();
        cleanLabels();
      }

      function start() {
        applyAll();
        var root = document.querySelector(ROOT_SELECTOR);
        if (!root || !('MutationObserver' in window)) return;

        var debounceTimer;
        var observer = new MutationObserver(function () {
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(applyAll, 50);
        });
        observer.observe(root, { childList: true, subtree: true });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
      } else {
        start();
      }

      // Firmhouse rendert soms ná DOMContentLoaded; retry kort.
      var retries = 0;
      var retryTimer = setInterval(function () {
        retries++;
        var existing = document.querySelector(TARGET_SELECTOR + ' .solvey-sub-bullets[' + INJECTED_FLAG + '="true"]');
        if ((existing && existing.dataset.bulletsHash === BULLETS_HASH) || retries > 20) {
          clearInterval(retryTimer);
          return;
        }
        applyAll();
      }, 250);
    })();
  });

  /* ---- trustpilot — was solvey-<x>-trustpilot.js (14x); Trustpilot-score naast de sterren, sterren klikbaar ---- */
  mod('trustpilot', cfg.kit && cfg.trustpilot === 'rating', function () {
    (function () {
      'use strict';
      if (!document.body.classList.contains('product-handle--' + cfg.kit)) return;

      var HOST_SELECTOR = '.product__primary-right .product-rating';
      var GUARD_ATTR = 'data-solvey-trust-injected';
      var TRUSTPILOT_URL = 'https://nl.trustpilot.com/review/solveyfem.com';
      // Teksten uit locales/*.json via window.solveyI18n (snippets/solvey-i18n.liquid);
      // Engelse tekst als fallback.
      var i18n = function (k, fb) { return (window.solveyI18n && window.solveyI18n[k]) || fb; };
      var SCORE_TEXT = i18n('trustpilot_score', '4.6/5 on');

      function findReviewsTarget() {
        var heads = document.querySelectorAll('h2, h3');
        for (var i = 0; i < heads.length; i++) {
          var t = heads[i].textContent.trim();
          if (/customers? tell it better|reviews|onze klanten|wat.*say|wat.*zeg/i.test(t)) {
            return heads[i].closest('.shopify-section, section') || heads[i];
          }
        }
        var slider = document.querySelector('[class*="testimonials-slider-wrapper"], [class*="testimonials-template"], [class*="ss-testimonial"]');
        if (slider) return slider.closest('.shopify-section') || slider;
        return document.querySelector('[class*="jdgm-rev-widg"], [id*="judgeme_product_reviews"]');
      }

      function makeClickable(rating) {
        if (!rating || rating.dataset.solveyClickable === '1') return;
        rating.dataset.solveyClickable = '1';
        rating.setAttribute('role', 'button');
        rating.setAttribute('tabindex', '0');
        rating.setAttribute('aria-label', i18n('read_reviews', 'Read customer reviews'));
        rating.style.cursor = 'pointer';

        var go = function (e) {
          var target = findReviewsTarget();
          if (!target) return;
          e.preventDefault();
          var top = target.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
        };
        rating.addEventListener('click', go);
        rating.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') go(e);
        });
      }

      function hideCount(rating) {
        var count = rating.querySelector('.product-rating__count');
        if (count) count.style.display = 'none';
      }

      function injectTrustpilot(rating) {
        if (rating.getAttribute(GUARD_ATTR) === '1') return;
        rating.setAttribute(GUARD_ATTR, '1');

        // Make rating a flex container so stars + trustpilot align
        rating.style.display = 'flex';
        rating.style.alignItems = 'center';
        rating.style.flexWrap = 'wrap';
        rating.style.gap = '10px';

        var link = document.createElement('a');
        link.href = TRUSTPILOT_URL;
        link.target = '_blank';
        link.rel = 'noopener';
        link.className = 'solvey-trustpilot-mention';
        link.setAttribute('aria-label', i18n('trustpilot_aria', '4.6 out of 5 on Trustpilot — opens in a new tab'));
        link.innerHTML = '<span class="solvey-trustpilot-text">' + SCORE_TEXT + ' <strong>Trustpilot</strong></span>';

        // Stop the parent click (review-scroll) from firing when user hits the trustpilot link
        link.addEventListener('click', function (e) { e.stopPropagation(); });

        rating.appendChild(link);
      }

      function run() {
        var ratings = document.querySelectorAll(HOST_SELECTOR);
        for (var i = 0; i < ratings.length; i++) {
          var r = ratings[i];
          hideCount(r);
          injectTrustpilot(r);
          makeClickable(r);
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
      } else {
        run();
      }

      // MutationObserver in case Shopify editor reloads the block
      var debounceTimer = null;
      var observer = new MutationObserver(function () {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(run, 50);
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    })();
  });

  /* ---- trustpilot-restore — was restore-probiotics-trustpilot.js ---- */
  mod('trustpilot-restore', cfg.trustpilot === 'below-price', function () {
    (function () {
      'use strict';

      var HOST_SELECTOR = '.product__rating-below-price';
      var GUARD_ATTR = 'data-solvey-trustpilot-injected';
      var TRUSTPILOT_URL = 'https://nl.trustpilot.com/review/solveyfem.com';
      // Teksten uit locales/*.json via window.solveyI18n (snippets/solvey-i18n.liquid);
      // Engelse tekst als fallback.
      var i18n = function (k, fb) { return (window.solveyI18n && window.solveyI18n[k]) || fb; };
      var SCORE_TEXT = i18n('trustpilot_score', '4.6/5 on');
      var BRAND_COLOR = '#00B67A'; // Trustpilot green

      function inject(root) {
        var scope = root && root.querySelectorAll ? root : document;
        var hosts = scope.querySelectorAll(HOST_SELECTOR);
        for (var i = 0; i < hosts.length; i++) {
          var host = hosts[i];
          if (host.getAttribute(GUARD_ATTR) === '1') continue;
          host.setAttribute(GUARD_ATTR, '1');

          // Make host a flex container so stars + trustpilot align on one line
          host.style.display = 'flex';
          host.style.alignItems = 'center';
          host.style.flexWrap = 'wrap';
          host.style.gap = '12px';

          var link = document.createElement('a');
          link.href = TRUSTPILOT_URL;
          link.target = '_blank';
          link.rel = 'noopener';
          link.className = 'solvey-trustpilot-mention';
          link.setAttribute('aria-label', i18n('trustpilot_aria', '4.6 out of 5 on Trustpilot — opens in a new tab'));

          link.innerHTML = '<span class="solvey-trustpilot-text">' + SCORE_TEXT + ' <strong>Trustpilot</strong></span>';

          host.appendChild(link);
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { inject(document); });
      } else {
        inject(document);
      }

      var debounceTimer = null;
      var observer = new MutationObserver(function () {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () { inject(document); }, 50);
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    })();
  });

  /* ---- ritual-cta — was restore-probiotics-ritual-cta.js ---- */
  mod('ritual-cta', cfg.ritualCta, function () {
    (function () {
      'use strict';

      var VARIANT_ID = 52150452617548;
      var SELLING_PLAN_ID = 691309314380; // Juo: elke 6 weken
      var BUTTON_SELECTOR = 'a[class^="ai-wellness-product__button-"]';
      var GUARD_ATTR = 'data-solvey-ritual-cta-bound';

      function bindButtons(root) {
        var scope = root && root.querySelectorAll ? root : document;
        var buttons = scope.querySelectorAll(BUTTON_SELECTOR);
        for (var i = 0; i < buttons.length; i++) {
          var btn = buttons[i];
          if (btn.hasAttribute(GUARD_ATTR)) continue;
          var text = (btn.textContent || '').trim();
          // Only bind the ritual CTA, not random other ai-wellness buttons
          if (!/ritueel|ritual/i.test(text)) continue;
          btn.setAttribute(GUARD_ATTR, '1');
          btn.addEventListener('click', handleClick);
        }
      }

      function handleClick(event) {
        event.preventDefault();
        event.stopPropagation();
        var btn = event.currentTarget;
        if (btn.getAttribute('data-solvey-busy') === '1') return;
        btn.setAttribute('data-solvey-busy', '1');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: VARIANT_ID,
              quantity: 1,
              selling_plan: SELLING_PLAN_ID
            }]
          })
        })
          .then(function (res) {
            if (!res.ok) throw new Error('cart/add failed: ' + res.status);
            return res.json();
          })
          .then(function () {
            // Naar de winkelwagen, niet /checkout: iDEAL en Bancontact voor
            // abonnementen lopen via de Juo-knop in de winkelwagen.
            window.location.href = '/cart';
          })
          .catch(function (err) {
            console.warn('[solvey-ritual-cta]', err);
            btn.removeAttribute('data-solvey-busy');
            // Fallback: navigate to cart so user is not stuck
            window.location.href = '/cart';
          });
      }

      // Initial bind
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () { bindButtons(document); });
      } else {
        bindButtons(document);
      }

      // Debounced MutationObserver for late-rendered DOM (Foxify section reloads, theme editor, etc.)
      var debounceTimer = null;
      var observer = new MutationObserver(function () {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(function () { bindButtons(document); }, 50);
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    })();
  });

  /* ---- preorder — was solvey-preorder.js ---- */
  mod('preorder', cfg.preorder, function () {
    (function () {
      if (!document.documentElement.classList.contains('solvey-preorder')) return;

      // Teksten uit locales/*.json via window.solveyI18n (snippets/solvey-i18n.liquid);
      // Engelse tekst als fallback.
      var i18n = function (k, fb) { return (window.solveyI18n && window.solveyI18n[k]) || fb; };

      /* ---------------- knop-label ---------------- */
      function getLabel() {
        var el = document.getElementById('solvey-preorder-data');
        return (el && el.getAttribute('data-label')) || i18n('preorder', 'Pre-order');
      }

      function relabelButtons(label) {
        var btns = document.querySelectorAll('[data-add-to-cart]');
        for (var i = 0; i < btns.length; i++) {
          var btn = btns[i];
          // Echt-uitverkocht (niet koopbaar) knoppen niet aanraken.
          if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') continue;
          // Al toegepast op dit knop-element? Dan niets doen.
          if (btn.getAttribute('data-solvey-preorder') === label) continue;

          // Update de reset-bron zodat de thema-JS ná add-to-cart óók "Pre-order" toont.
          btn.setAttribute('data-lang-available', label);
          btn.setAttribute('aria-label', label);
          var span = btn.querySelector('[data-add-to-cart-text]');
          if (span) span.textContent = label;
          btn.setAttribute('data-solvey-preorder', label);
        }
      }

      /* ---------------- header-badge (met levertijd) ---------------- */
      // Teksten uit de locale-files (products.product.preorder +
      // solvey_ui.js.preorder_delivery) via window.solveyI18n.
      function badgeText() {
        return i18n('preorder', 'Pre-order') + ' · ' + i18n('preorder_delivery', 'Delivery ± 1 week');
      }

      function ensureBadge() {
        var host = document.querySelector('.product__block--product-header-inner');
        if (!host) return;
        var badge = host.querySelector('.solvey-preorder-badge');
        if (badge) {
          if (badge.textContent !== badgeText()) badge.textContent = badgeText();
          return;
        }
        badge = document.createElement('span');
        badge.className = 'solvey-preorder-badge';
        badge.textContent = badgeText();
        var title = host.querySelector('.product__title');
        host.insertBefore(badge, title || host.firstChild);
      }

      function apply() {
        relabelButtons(getLabel());
        ensureBadge();
      }

      function boot() {
        apply();
        // Late DOM / variant-swap: opnieuw toepassen bij mutaties.
        // rAF-debounce + idempotente guards voorkomen een observer-loop.
        var queued = false;
        var obs = new MutationObserver(function () {
          if (queued) return;
          queued = true;
          requestAnimationFrame(function () { queued = false; apply(); });
        });
        obs.observe(document.body, { childList: true, subtree: true });
        window.addEventListener('pageshow', apply);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
      } else {
        boot();
      }
    })();
  });

  /* ---- ad-autocart — was solvey-ad-autocart.js; alle productpagina's, reageert alleen op ?solvey_autocart=1 ---- */
  mod('ad-autocart', true, function () {
    (function () {
      'use strict';

      var PARAM = 'solvey_autocart';
      var OPEN_FLAG = 'solvey_autocart_open';

      function getMarker() {
        try {
          return new URLSearchParams(window.location.search).get(PARAM);
        } catch (e) {
          return null;
        }
      }

      function reloadWithoutMarker() {
        try {
          var url = new URL(window.location.href);
          url.searchParams.delete(PARAM);
          window.location.replace(url.pathname + url.search + url.hash);
        } catch (e) {
          window.location.reload();
        }
      }

      // --- Fase 2: drawer openen na de reload ---------------------------------
      function openDrawerAfterReload() {
        var flag;
        try { flag = sessionStorage.getItem(OPEN_FLAG); } catch (e) {}
        if (flag !== '1') return;
        try { sessionStorage.removeItem(OPEN_FLAG); } catch (e) {}

        var tries = 0;
        (function attempt() {
          tries++;
          var wrapper = document.querySelector('.quick-cart__wrapper');
          if (wrapper && wrapper.classList.contains('active')) return; // al open
          var trigger = document.querySelector('[data-solvey-cart-trigger]');
          if (trigger) trigger.click();
          if (tries < 24) setTimeout(attempt, 250); // ~6s ruimte voor theme-init
        })();
      }

      // --- Fase 1: item toevoegen en herladen ---------------------------------
      function addThenReload() {
        var match = window.location.pathname.match(/\/products\/([^\/?#]+)/);
        if (!match) {
          reloadWithoutMarker();
          return;
        }
        var handle = match[1];

        fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (product) {
            var variants = (product && product.variants) || [];
            var variant = variants.filter(function (v) { return v.available; })[0] || variants[0];
            if (!variant) return null;
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
            });
          })
          .then(function (r) { return r ? r.json() : null; })
          .then(function (res) {
            if (res && !res.status) {
              try { sessionStorage.setItem(OPEN_FLAG, '1'); } catch (e) {}
            }
            reloadWithoutMarker();
          })
          .catch(function () {
            reloadWithoutMarker();
          });
      }

      function run() {
        if (getMarker() === '1') {
          addThenReload();
        } else {
          openDrawerAfterReload();
        }
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', run);
      } else {
        run();
      }
    })();
  });

  /* ---- frequency-dropdown — was solvey-frequency-dropdown.js ---- */
  mod('frequency-dropdown', cfg.core, function () {
    (function () {
      var ATTACHED = 'solveyFqAttached';

      // Walk up; warn + neutralize any ancestor that clips the panel.
      // Alleen op mobile uitgevoerd: anders gaan we niet lopen modden in styles
      // die op desktop niet relevant zijn.
      function auditOverflow(sel) {
        var el = sel.parentElement;
        while (el && el !== document.body) {
          var cs = getComputedStyle(el);
          if (cs.overflow === 'hidden' || cs.overflowY === 'hidden' || cs.overflowX === 'hidden') {
            if (window.console && console.warn) {
              console.warn('[solvey-fq] overflow:hidden ancestor neutralised on mobile:', el);
            }
            el.style.setProperty('overflow', 'visible', 'important');
          }
          el = el.parentElement;
        }
      }

      function attach() {
        var selects = document.querySelectorAll('select.frequency-select');
        for (var s = 0; s < selects.length; s++) {
          var sel = selects[s];
          if (sel.dataset[ATTACHED]) continue;
          sel.dataset[ATTACHED] = '1';

          var wrapper = sel.parentElement;
          if (!wrapper) continue;

          if (window.matchMedia('(max-width: 749px)').matches) {
            auditOverflow(sel);
          }

          // Trigger
          var trigger = document.createElement('button');
          trigger.type = 'button';
          trigger.className = 'solvey-fq-trigger';
          trigger.setAttribute('aria-haspopup', 'listbox');
          trigger.setAttribute('aria-expanded', 'false');
          trigger.setAttribute('aria-label', (window.solveyI18n && window.solveyI18n.delivery_frequency) || 'Delivery frequency');

          var labelSpan = document.createElement('span');
          labelSpan.className = 'solvey-fq-trigger-label';
          labelSpan.textContent = sel.options[sel.selectedIndex].text;
          trigger.appendChild(labelSpan);

          // Panel
          var panel = document.createElement('ul');
          panel.className = 'solvey-fq-panel';
          panel.setAttribute('role', 'listbox');
          panel.hidden = true;

          var items = [];
          (function buildOptions() {
            for (var i = 0; i < sel.options.length; i++) {
              (function (idx) {
                var opt = sel.options[idx];
                var li = document.createElement('li');
                li.setAttribute('role', 'option');
                li.setAttribute('tabindex', '-1');
                li.dataset.value = opt.value;
                li.textContent = opt.text;
                if (idx === sel.selectedIndex) li.setAttribute('aria-selected', 'true');
                li.addEventListener('click', function () { choose(idx); });
                li.addEventListener('keydown', function (e) {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    choose(idx);
                  } else if (e.key === 'ArrowDown') {
                    e.preventDefault();
                    items[Math.min(idx + 1, items.length - 1)].focus();
                  } else if (e.key === 'ArrowUp') {
                    e.preventDefault();
                    items[Math.max(idx - 1, 0)].focus();
                  } else if (e.key === 'Escape') {
                    close();
                    trigger.focus();
                  }
                });
                panel.appendChild(li);
                items.push(li);
              })(i);
            }
          })();

          function choose(i) {
            sel.selectedIndex = i;
            sel.dispatchEvent(new Event('change', { bubbles: true }));
            labelSpan.textContent = sel.options[i].text;
            for (var j = 0; j < items.length; j++) {
              if (j === i) items[j].setAttribute('aria-selected', 'true');
              else items[j].removeAttribute('aria-selected');
            }
            close();
            trigger.focus();
          }

          function open() {
            panel.hidden = false;
            trigger.setAttribute('aria-expanded', 'true');
            var i = sel.selectedIndex;
            if (items[i]) {
              items[i].setAttribute('tabindex', '0');
              setTimeout(function () { items[i] && items[i].focus(); }, 0);
            }
          }

          function close() {
            panel.hidden = true;
            trigger.setAttribute('aria-expanded', 'false');
            for (var k = 0; k < items.length; k++) items[k].setAttribute('tabindex', '-1');
          }

          trigger.addEventListener('click', function (e) {
            e.preventDefault();
            if (panel.hidden) open();
            else close();
          });
          trigger.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowDown' || e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              open();
            }
          });

          // Bound aan wrapper-instance zodat closures niet lekken bij re-render
          (function (w) {
            document.addEventListener('click', function (e) {
              if (!w.contains(e.target)) close();
            });
          })(wrapper);
          document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape') close();
          });

          // Plaats trigger op de positie van de select (vóór .nextSibling), niet
          // achter het 15%-badge. Panel komt direct na de trigger.
          wrapper.insertBefore(trigger, sel.nextSibling);
          wrapper.insertBefore(panel, trigger.nextSibling);

          // Activeer de hiding-CSS pas nu de trigger bestaat — voorkomt leeg gat
          // tijdens defer-window of bij JS-fail.
          wrapper.classList.add('solvey-fq-active');

          // Sync wanneer Firmhouse-app de select extern wijzigt
          sel.addEventListener('change', function () {
            var i = sel.selectedIndex;
            labelSpan.textContent = sel.options[i].text;
            for (var k = 0; k < items.length; k++) {
              if (k === i) items[k].setAttribute('aria-selected', 'true');
              else items[k].removeAttribute('aria-selected');
            }
          });

          // Re-sync alle custom dropdown teksten vanuit de native <option>s.
          // Reden: Firmhouse (of ons eigen i18n-script) kan de native options
          // ná het bouwen van de custom labelSpan + li-items nog herschrijven.
          // Defensief: observe de native select op characterData/childList
          // mutaties en mirror de option-tekst naar ons custom DOM.
          var resyncing = false;
          function resyncFromNative() {
            if (resyncing) return;
            resyncing = true;
            try {
              var idx = sel.selectedIndex;
              if (idx >= 0 && sel.options[idx]) {
                labelSpan.textContent = sel.options[idx].text;
              }
              for (var k = 0; k < items.length && k < sel.options.length; k++) {
                var newText = sel.options[k].text;
                if (items[k].textContent !== newText) items[k].textContent = newText;
              }
            } finally {
              resyncing = false;
            }
          }
          var textObserver = new MutationObserver(function () { resyncFromNative(); });
          textObserver.observe(sel, { childList: true, subtree: true, characterData: true });
        }
      }

      function init() {
        attach();
        // Idempotent: re-attach als Firmhouse de subscription-block re-rendert
        var observer = new MutationObserver(function () {
          clearTimeout(window.__solveyFqDebounce);
          window.__solveyFqDebounce = setTimeout(attach, 50);
        });
        observer.observe(document.body, { childList: true, subtree: true });
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
      } else {
        init();
      }
    })();
  });

  /* ---- product-header — was solvey-product-header.js ---- */
  mod('product-header', cfg.core, function () {
    (function () {
      'use strict';
      if (window.__solveyProductHeaderInit) return;
      var DOTS_HANDLES = [
        'product-handle--restore-probiotics',
        'product-handle--urinary-tract-blend',
        'product-handle--carvacrol-complex-oregano-oil',
        'product-handle--boric-acid-600mg-vaginal-suppositories',
        'product-handle--vaginal-balance-bundle',
        'product-handle--total-reset-bundle',
        'product-handle--double-trouble-bundle',
        'product-handle--full-bladder-support',
        'product-handle--pregnancy-support-bundle',
        'product-handle--restore-probiotics-intimate-care-cream',
        'product-handle--clear-out-patches-with-salicylic-acid',
        'product-handle--intimate-care-cream',
        'product-handle--intimate-shave-bar',
        'product-handle--prepare-prenatal-pregnancy-supplement',
        'product-handle--vaginale-schimmelinfectie-zelftest'
      ];
      var IS_PROBIOTICS = document.body.classList.contains('product-handle--restore-probiotics');
      var IS_DOTS_PDP = DOTS_HANDLES.some(function (h) { return document.body.classList.contains(h); });
      if (!IS_DOTS_PDP) return;
      window.__solveyProductHeaderInit = true;

      // Teksten uit locales/*.json via window.solveyI18n (snippets/solvey-i18n.liquid);
      // Engelse tekst als fallback.
      var i18n = function (k, fb) { return (window.solveyI18n && window.solveyI18n[k]) || fb; };

      var DEBOUNCE = 50;
      var MOBILE_MQ = window.matchMedia('(max-width: 749px)');

      function debounce(fn, ms) {
        var t; return function () {
          clearTimeout(t);
          var a = arguments, c = this;
          t = setTimeout(function(){ fn.apply(c, a); }, ms);
        };
      }

      /* ---------- 1. Gallery dots (mobile only) ---------- */
      function initGalleryDots() {
        var container = document.querySelector('.product__media-container');
        if (!container) return;
        var thumbs = container.querySelectorAll('.product-thumbnails__item-link');
        if (!thumbs.length) return;

        var existing = container.querySelector('.solvey-gallery-dots');

        // Idempotence: rebuild only if thumb-count changed (robust against variant placeholders)
        if (existing && existing.dataset.thumbCount === String(thumbs.length)) {
          var dotsNow = existing.querySelectorAll('.solvey-gallery-dots__dot');
          thumbs.forEach(function (t, i) {
            if (dotsNow[i]) dotsNow[i].setAttribute('aria-current', t.classList.contains('active') ? 'true' : 'false');
          });
          return;
        }

        if (existing) existing.remove();

        var dotsEl = document.createElement('ul');
        dotsEl.className = 'solvey-gallery-dots';
        dotsEl.setAttribute('data-solvey-gallery-dots', '');
        dotsEl.dataset.thumbCount = String(thumbs.length);
        dotsEl.setAttribute('aria-label', i18n('gallery_pagination', 'Product image pagination'));

        thumbs.forEach(function (thumb, i) {
          var li = document.createElement('li');
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'solvey-gallery-dots__dot';
          btn.setAttribute('aria-label', i18n('gallery_dot', 'Show image [n]').replace('[n]', i + 1));
          btn.setAttribute('aria-current', thumb.classList.contains('active') ? 'true' : 'false');
          btn.addEventListener('click', function () { thumb.click(); });
          li.appendChild(btn);
          dotsEl.appendChild(li);
        });

        var media = container.querySelector('.product__media');
        if (media && media.parentNode === container) {
          container.insertBefore(dotsEl, media.nextSibling);
        } else {
          container.appendChild(dotsEl);
        }
      }

      /* ---------- 1b. Gallery swipe (mobile only) ----------
         Foxify gallery hides non-active media-items via `.hidden` and provides
         no native touch handling. We bridge that by mapping a horizontal swipe
         on the visible image to a thumb-click (which already drives the gallery
         and updates dots/active-state via the existing MutationObserver). */
      function initGallerySwipe() {
        var media = document.querySelector('.product__media');
        if (!media || media.dataset.solveySwipe === '1') return;
        media.dataset.solveySwipe = '1';

        var MIN_DX = 40;       // px — minimum horizontal travel
        var DOMINANCE = 1.2;   // |dx| must exceed |dy| * DOMINANCE to count as horizontal

        var startX = 0, startY = 0, tracking = false;

        media.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { tracking = false; return; }
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          tracking = true;
        }, { passive: true });

        media.addEventListener('touchend', function (e) {
          if (!tracking) return;
          tracking = false;
          var t = e.changedTouches[0];
          var dx = t.clientX - startX;
          var dy = t.clientY - startY;
          if (Math.abs(dx) < MIN_DX) return;
          if (Math.abs(dx) < Math.abs(dy) * DOMINANCE) return;

          var container = document.querySelector('.product__media-container');
          if (!container) return;
          var thumbs = container.querySelectorAll('.product-thumbnails__item-link');
          if (!thumbs.length) return;
          var idx = -1;
          for (var i = 0; i < thumbs.length; i++) {
            if (thumbs[i].classList.contains('active')) { idx = i; break; }
          }
          if (idx < 0) idx = 0;
          var next = dx < 0 ? idx + 1 : idx - 1;
          if (next < 0 || next >= thumbs.length) return;
          thumbs[next].click();
        }, { passive: true });
      }

      /* ---------- 2. Re-parent rating into price wrap ---------- */
      function initPriceRatingInline() {
        var inner = document.querySelector('.product__block--product-header-inner');
        if (!inner) return;
        var priceWrap = inner.querySelector('.product__price-and-ratings');
        var ratingWrap = inner.querySelector('.product__rating-below-price');
        if (!priceWrap || !ratingWrap) return;
        if (ratingWrap.parentNode === priceWrap) {
          inner.dataset.solveyHeaderInline = '1';
          return;
        }
        priceWrap.appendChild(ratingWrap);
        inner.dataset.solveyHeaderInline = '1';
      }

      /* ---------- 3. Clickable rating ---------- */
      function findReviewsTarget() {
        var heads = document.querySelectorAll('h2');
        for (var i = 0; i < heads.length; i++) {
          var t = heads[i].textContent.trim();
          if (/customers? tell it better|reviews|what.*say/i.test(t)) {
            return heads[i].closest('.shopify-section, section, [class*="section-"]') || heads[i];
          }
        }
        var slider = document.querySelector('[class*="testimonials-slider-wrapper"], [class*="testimonials-template"]');
        if (slider) return slider.closest('.shopify-section') || slider;
        return document.querySelector('[class*="jdgm-rev-widg"], [id*="judgeme_product_reviews"]');
      }

      function initRatingClickable() {
        var rating = document.querySelector('.product__rating-below-price .product-rating');
        if (!rating || rating.dataset.solveyClickable === '1') return;
        rating.dataset.solveyClickable = '1';
        rating.setAttribute('role', 'button');
        rating.setAttribute('tabindex', '0');
        rating.setAttribute('aria-label', i18n('read_reviews', 'Read customer reviews'));

        var go = function (e) {
          var target = findReviewsTarget();
          if (!target) return;
          e.preventDefault();
          var top = target.getBoundingClientRect().top + window.scrollY - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
        };
        rating.addEventListener('click', go);
        rating.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') go(e);
        });
      }

      /* ---------- 4. Quantity inline (CSS does the work) ---------- */
      function initQuantityInline() {
        var group = document.querySelector('.product__controls-group-quantity');
        if (!group || group.dataset.solveyQtyInline === '1') return;
        group.dataset.solveyQtyInline = '1';
      }

      /* ---------- Run all init functions ---------- */
      var run = debounce(function () {
        if (IS_PROBIOTICS) {
          initPriceRatingInline();
          initRatingClickable();
        }
        initQuantityInline();
        if (MOBILE_MQ.matches) {
          initGalleryDots();
          initGallerySwipe();
        }
      }, DEBOUNCE);

      /* ---------- Idempotent observer attach ---------- */
      function attachObservers() {
        var headerInner = document.querySelector('.product__block--product-header-inner');
        if (headerInner && headerInner.dataset.solveyObserved !== '1') {
          headerInner.dataset.solveyObserved = '1';
          new MutationObserver(run).observe(headerInner, {
            childList: true,
            subtree: true
          });
        }
        var galleryContainer = document.querySelector('.product__media-container');
        if (galleryContainer && galleryContainer.dataset.solveyObserved !== '1') {
          galleryContainer.dataset.solveyObserved = '1';
          new MutationObserver(run).observe(galleryContainer, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
          });
        }
      }

      /* ---------- Boot ---------- */
      function boot() {
        run();
        attachObservers();
      }

      /* ---------- Viewport breakpoint changes ---------- */
      var onMq = function () {
        if (!MOBILE_MQ.matches) {
          var stale = document.querySelector('.solvey-gallery-dots');
          if (stale) stale.remove();
          // Allow re-init on next mobile entry; touch listeners do nothing on desktop anyway
          var media = document.querySelector('.product__media');
          if (media) delete media.dataset.solveySwipe;
        }
        run();
      };
      if (MOBILE_MQ.addEventListener) MOBILE_MQ.addEventListener('change', onMq);
      else MOBILE_MQ.addListener(onMq);

      /* ---------- Shopify editor section/block reload ---------- */
      // After a section reload the previous header-inner / media-container nodes are detached.
      // Their dataset.solveyObserved flag dies with them, so attachObservers() will re-attach
      // to the new nodes without duplicating observers on the surviving ones.
      ['shopify:section:load', 'shopify:section:reload', 'shopify:block:select', 'shopify:block:deselect'].forEach(function (ev) {
        document.addEventListener(ev, function () {
          // Reset re-parent guard since header-inner may be a fresh node
          if (IS_PROBIOTICS) {
            var inner = document.querySelector('.product__block--product-header-inner');
            if (inner) delete inner.dataset.solveyHeaderInline;
          }
          boot();
        });
      });

      /* ---------- Initial boot ---------- */
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
      } else {
        boot();
      }
    })();
  });

  /* ---- firmhouse-i18n — was solvey-firmhouse-i18n.js ---- */
  mod('firmhouse-i18n', cfg.core, function () {
    (function () {
      'use strict';

      /* Teksten komen uit locales/*.json via window.solveyI18n
         (snippets/solvey-i18n.liquid); de Engelse tekst is de fallback. */
      var i18n = function (k, fb) { return (window.solveyI18n && window.solveyI18n[k]) || fb; };

      /* ---- Selling-plan group name --------------------------- */
      var PLAN_LABEL = i18n('plan_subscribe_save', 'Subscribe & Save');
      // Alleen deze bekende varianten worden overschreven (detectie, geen weergave).
      var ALL_PLAN_LABELS = [
        'Subscribe & Save',
        'Abonneer & Bespaar',
        'Abonnieren & Sparen',
        'Abonnér & Spar',
        'Abonner & Économiser',
        PLAN_LABEL
      ];

      /* ---- Solvey sub-bullets (EN bron-tekst -> i18n-sleutel) ---------- */
      // restore-probiotics-bullets.js zet nog Engelse tekst neer; de
      // solvey-*-bullets.js en solvey-shavebar-pack.js zetten al de vertaalde
      // tekst. Deze map vertaalt de Engelse bron alsnog naar de actieve taal.
      var BULLET_KEYS = {
        'Trusted by 30,000+ women': 'sub_bullet_trusted',
        '100% Natural & Clinically Tested': 'sub_bullet_natural',
        'Expertly developed with gynecological input': 'sub_bullet_expert',
        '60-day money-back guarantee': 'sub_bullet_guarantee',
        'Flexible subscription, cancel anytime': 'sub_bullet_flexible',
        /* Shave Bar — 2-pack card bullets (solvey-shavebar-pack.js,
           <ul class="solvey-pack-bullets">). */
        'Best value: save the most': 'pack_bullet_value',
        'Long-lasting care for smooth, comfortable skin': 'pack_bullet_care',
        'Fewer reorders, more convenience': 'pack_bullet_reorders',
        'Always have a backup on hand': 'pack_bullet_backup',
        'Pause or cancel anytime': 'pack_bullet_pause'
      };

      /* ---- Tagline onder de cards (was CSS ::after, niet vertaalbaar) ---- */
      var TAGLINE = {
        nl: 'Gebruik 2-3 maanden voor het beste resultaat',
        en: 'Use for 2-3 months for optimal results',
        de: '2-3 Monate verwenden für optimale Ergebnisse',
        da: 'Brug i 2-3 måneder for optimale resultater',
        fr: 'Utiliser pendant 2-3 mois pour des résultats optimaux'
      };

      /* Carvacrol-PDP heeft een afwijkende tagline (1 maand i.p.v. 2-3) */
      var TAGLINE_OVERRIDES = {
        'product-handle--carvacrol-complex-oregano-oil': {
          nl: 'Gebruik 1 maand voor het beste resultaat',
          en: 'Use 1 month for optimal results',
          de: '1 Monat verwenden für optimale Ergebnisse',
          da: 'Brug i 1 måned for optimale resultater',
          fr: 'Utiliser pendant 1 mois pour des résultats optimaux'
        }
      };

      function currentLang() {
        if (window.Shopify && window.Shopify.locale) {
          return String(window.Shopify.locale).toLowerCase().split('-')[0];
        }
        if (document.documentElement.lang) {
          return String(document.documentElement.lang).toLowerCase().split('-')[0];
        }
        return 'nl';
      }

      function translatePlanLabels() {
        var label = PLAN_LABEL;
        var nodes = document.querySelectorAll('li.subscription-card .option-name, .subscription-card .option-name');
        nodes.forEach(function (el) {
          var txt = el.textContent.trim();
          if (txt === label) return;
          if (ALL_PLAN_LABELS.indexOf(txt) !== -1 || txt === '') {
            el.textContent = label;
          }
        });
      }

      function translateBullets() {
        // .solvey-sub-bullets = globale 5 bullets per PDP (via solvey-*-bullets.js)
        // .solvey-pack-bullets = shave-bar 2-pack card bullets (via solvey-shavebar-pack.js)
        var nodes = document.querySelectorAll('.solvey-sub-bullets li span, .solvey-pack-bullets li span');
        nodes.forEach(function (span) {
          var txt = span.textContent.trim();
          var key = BULLET_KEYS[txt];
          if (!key) return;
          var target = i18n(key, txt);
          if (!target || txt === target) return;
          span.textContent = target;
        });
      }

      // NVWA-compliance (2026-06-22): de tagline onder de subscription/one-time
      // cards ("Use for 2-3 months for optimal results" en varianten) moet volledig
      // weg van ÁLLE PDP's. We injecteren niets meer en verwijderen actief een
      // eventueel al aanwezige span (ook na re-render).
      // TAGLINE / TAGLINE_OVERRIDES blijven staan zodat dit makkelijk terug te
      // draaien is als het ooit weer mag.
      function translateTagline(lang) {
        document.querySelectorAll('.solvey-firmhouse-tagline').forEach(function (span) {
          span.remove();
        });
      }

      /* ---- Frequentie-sublabel onder de plannaam ------------- */
      // Owner-wens 2026-07-01: onder "Abonneer & Bespaar" moet "elke 6 weken"
      // (EN "every 6 weeks", enz.) staan. We wrappen .option-name samen met een
      // lege <span class="solvey-fq-sub"> in een kolom-div; de zichtbare tekst
      // komt uit CSS ::after per html[lang] (zie custom.css). Idempotent + herbouwt zichzelf na elke Firmhouse-rerender via
      // de body-MutationObserver. Alleen op de subscription-card (niet one-time).
      function ensureFreqLabel() {
        var rows = document.querySelectorAll('li.subscription-card .card-header .card-row');
        rows.forEach(function (row) {
          var on = row.querySelector('.option-name');
          if (!on) return;
          var col = on.parentElement;
          if (!col || !col.classList || !col.classList.contains('solvey-plan-col')) {
            col = document.createElement('div');
            col.className = 'solvey-plan-col';
            on.parentElement.insertBefore(col, on);
            col.appendChild(on);
          }
          if (!col.querySelector('.solvey-fq-sub')) {
            var sub = document.createElement('span');
            sub.className = 'solvey-fq-sub';
            col.appendChild(sub);
          }
        });
      }

      function translateAll() {
        var lang = currentLang();
        translatePlanLabels();
        translateBullets();
        translateTagline(lang);
        ensureFreqLabel();
      }

      var debounceTimer = null;
      function scheduleTranslate() {
        if (debounceTimer) clearTimeout(debounceTimer);
        debounceTimer = setTimeout(translateAll, 50);
      }

      var bodyObserver = null;
      function startBodyObserver() {
        if (bodyObserver || !document.body) return;
        bodyObserver = new MutationObserver(scheduleTranslate);
        bodyObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
      }

      function boot() {
        startBodyObserver();
        translateAll();

        var tries = 0;
        var poll = setInterval(function () {
          tries++;
          scheduleTranslate();
          if (tries > 50) clearInterval(poll);
        }, 200);
      }

      window.addEventListener('pageshow', scheduleTranslate);
      window.addEventListener('focus', scheduleTranslate);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) scheduleTranslate();
      });

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
      } else {
        boot();
      }
    })();
  });

  /* ---- vip-card — was solvey-vip-card.js ---- */
  mod('vip-card', cfg.core, function () {
    (function () {
      'use strict';

      // Teksten uit locales/*.json via window.solveyI18n (snippets/solvey-i18n.liquid);
      // Engelse tekst als fallback.
      var i18n = function (k, fb) { return (window.solveyI18n && window.solveyI18n[k]) || fb; };
      var LANGS = {
        heading: i18n('vip_heading', 'VIP Member Benefits'),
        body: i18n('vip_body', 'Be the first to hear about new launches, exclusive offers and subscriber-only gifts.'),
        member: i18n('vip_member', 'MEMBER')
      };

      var CROWN =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M11.562 3.266a.5.5 0 0 1 .876 0L15.39 8.87a1 1 0 0 0 1.516.294L21.183 5.5a.5.5 0 0 1 .798.519l-2.834 10.246a1 1 0 0 1-.956.734H5.81a1 1 0 0 1-.957-.734L2.02 6.02a.5.5 0 0 1 .798-.519l4.276 3.664a1 1 0 0 0 1.516-.294z"/>' +
        '<path d="M5 21h14"/>' +
        '</svg>';

      // Append aan de li (binnen de groene rand) i.p.v. .card-content: .card-content
      // is ingesprongen voorbij het radio-bolletje, waardoor de VIP-card links méér
      // padding kreeg dan rechts. De li-content-box geeft symmetrische 16px links+rechts.
      var TARGET_SELECTOR = '.selling_plan_app_container li.subscription-card';
      var ROOT_SELECTOR = '.selling_plan_app_container';
      var FLAG = 'data-solvey-vip';

      function currentLang() {
        if (window.Shopify && window.Shopify.locale) return String(window.Shopify.locale).toLowerCase().split('-')[0];
        if (document.documentElement.lang) return String(document.documentElement.lang).toLowerCase().split('-')[0];
        return 'nl';
      }

      function t(group) {
        return LANGS[group];
      }

      function buildCard(lang) {
        var card = document.createElement('div');
        card.className = 'solvey-vip-card';
        card.setAttribute(FLAG, 'true');
        card.innerHTML =
          '<div class="solvey-vip-card__sparkles" aria-hidden="true">' +
            '<span class="solvey-vip-card__sparkle solvey-vip-card__sparkle--1">&#10022;</span>' +
            '<span class="solvey-vip-card__sparkle solvey-vip-card__sparkle--2">&#10022;</span>' +
          '</div>' +
          '<div class="solvey-vip-card__text">' +
            '<div class="solvey-vip-card__heading">' + t('heading', lang) + '</div>' +
            '<div class="solvey-vip-card__body">' + t('body', lang) + '</div>' +
          '</div>' +
          '<div class="solvey-vip-card__badge" aria-hidden="true">' +
            CROWN +
            '<span class="solvey-vip-card__badge-vip">VIP</span>' +
            '<span class="solvey-vip-card__badge-member">' + t('member') + '</span>' +
          '</div>';
        return card;
      }

      function updateText(card, lang) {
        var h = card.querySelector('.solvey-vip-card__heading');
        var b = card.querySelector('.solvey-vip-card__body');
        if (h && h.textContent !== t('heading', lang)) h.textContent = t('heading', lang);
        if (b && b.textContent !== t('body', lang)) b.textContent = t('body', lang);
      }

      function apply() {
        var lang = currentLang();
        var targets = document.querySelectorAll(TARGET_SELECTOR);
        for (var i = 0; i < targets.length; i++) {
          var existing = targets[i].querySelector('.solvey-vip-card[' + FLAG + '="true"]');
          if (existing) {
            updateText(existing, lang);
          } else {
            targets[i].appendChild(buildCard(lang));
          }
        }
      }

      var debounce;
      function schedule() {
        clearTimeout(debounce);
        debounce = setTimeout(apply, 50);
      }

      function start() {
        apply();
        var root = document.querySelector(ROOT_SELECTOR);
        if (root && 'MutationObserver' in window) {
          new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
        }
        window.addEventListener('pageshow', schedule);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
      } else {
        start();
      }

      // Firmhouse rendert soms laat — retry kort.
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        apply();
        if (tries > 24) clearInterval(timer);
      }, 250);
    })();
  });

  /* ---- gift-card — was solvey-gift-card.js; afbeelding via window.SOLVEY_GIFT_CARD ---- */
  mod('gift-card', cfg.gift, function () {
    (function () {
      'use strict';

      var CFG = window.SOLVEY_GIFT_CARD || {};
      if (!CFG.image) return; // niets te tonen zonder product-image

      // "Worth"-anchor + productnaam centraal (owner kan hier tweaken).
      var WORTH = CFG.worth || '€19,95';
      var TITLE = CFG.title || 'Solvey Intimate Care Cream';

      // Teksten uit locales/*.json via window.solveyI18n (snippets/solvey-i18n.liquid);
      // Engelse tekst als fallback.
      var i18n = function (k, fb) { return (window.solveyI18n && window.solveyI18n[k]) || fb; };
      var LANGS = {
        pill: i18n('gift_pill', 'Free with your subscription'),
        // doorgestreept label vóór de prijs, bv. "Worth €19,95"
        worth: i18n('gift_worth', 'Worth'),
        free: i18n('gift_free', 'Free — added to your cart')
      };

      var TARGET_SELECTOR = '.selling_plan_app_container li.subscription-card';
      var ROOT_SELECTOR = '.selling_plan_app_container';
      var VIP_SELECTOR = '.solvey-vip-card';
      var FLAG = 'data-solvey-gift-card';

      function currentLang() {
        if (window.Shopify && window.Shopify.locale) return String(window.Shopify.locale).toLowerCase().split('-')[0];
        if (document.documentElement.lang) return String(document.documentElement.lang).toLowerCase().split('-')[0];
        return 'nl';
      }

      function t(group) {
        return LANGS[group];
      }

      function buildCard(lang) {
        var card = document.createElement('div');
        card.className = 'solvey-gift-card';
        card.setAttribute(FLAG, 'true');
        card.innerHTML =
          '<div class="solvey-gift-card__plus" aria-hidden="true">+</div>' +
          '<img class="solvey-gift-card__img" src="' + CFG.image + '" alt="" loading="lazy" width="84" height="72">' +
          '<div class="solvey-gift-card__text">' +
            '<div class="solvey-gift-card__pill">' + t('pill', lang) + '</div>' +
            '<div class="solvey-gift-card__title">' + TITLE + '</div>' +
            '<div class="solvey-gift-card__value">' +
              '<span class="solvey-gift-card__worth">' + t('worth', lang) + ' ' + WORTH + '</span>' +
              '<span class="solvey-gift-card__free">' + t('free', lang) + '</span>' +
            '</div>' +
          '</div>';
        return card;
      }

      function updateText(card, lang) {
        var pill = card.querySelector('.solvey-gift-card__pill');
        var worth = card.querySelector('.solvey-gift-card__worth');
        var free = card.querySelector('.solvey-gift-card__free');
        if (pill && pill.textContent !== t('pill', lang)) pill.textContent = t('pill', lang);
        var worthTxt = t('worth', lang) + ' ' + WORTH;
        if (worth && worth.textContent !== worthTxt) worth.textContent = worthTxt;
        if (free && free.textContent !== t('free', lang)) free.textContent = t('free', lang);
      }

      // Plaats de card altijd direct vóór de VIP-card als die er is; anders append.
      // (VIP-card append't zichzelf als laatste child -> zonder herplaatsing zou de
      // gift-card ná de VIP-card belanden bij een race.) Guard voorkomt observer-loop.
      function place(target, node) {
        var vip = target.querySelector(VIP_SELECTOR);
        if (vip) {
          if (node.nextElementSibling !== vip) target.insertBefore(node, vip);
        } else if (target.lastElementChild !== node) {
          target.appendChild(node);
        }
      }

      function apply() {
        var lang = currentLang();
        var targets = document.querySelectorAll(TARGET_SELECTOR);
        for (var i = 0; i < targets.length; i++) {
          var existing = targets[i].querySelector('.solvey-gift-card[' + FLAG + '="true"]');
          if (!existing) existing = buildCard(lang);
          else updateText(existing, lang);
          place(targets[i], existing);
        }
      }

      var debounce;
      function schedule() {
        clearTimeout(debounce);
        debounce = setTimeout(apply, 50);
      }

      function start() {
        apply();
        var root = document.querySelector(ROOT_SELECTOR);
        if (root && 'MutationObserver' in window) {
          new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
        }
        window.addEventListener('pageshow', schedule);
      }

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', start);
      } else {
        start();
      }

      // Firmhouse rendert soms laat — retry kort.
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        apply();
        if (tries > 24) clearInterval(timer);
      }, 250);
    })();
  });
})();
